import React from "react";
import Photo from "./Photo";
import photos from "../../data/photography.json";

const find = (slug) => photos.find((p) => p.slug === slug);

// Asymmetric editorial gallery — mix of moody Dosa Hut + bright Laddu Gopal
// to show tonal range. Real photography from the curated library.
export const GalleryGrid = () => {
  // Curated layout — best-in-class shots, intentional tonal variety
  const layout = [
    { slug: "hero-raj-kachori-08", ratio: "4/5", caption: "Raj Kachori · Hero", col: "col-span-12 md:col-span-7", offset: "" },
    { slug: "hero-spread-01", ratio: "3/4", caption: "Catering · Spread", col: "col-span-7 md:col-span-5", offset: "md:mt-20" },
    { slug: "hero-laddu-220", ratio: "1/1", caption: "Saffron · Bowl", col: "col-span-5 md:col-span-3", offset: "md:mt-8" },
    { slug: "hero-gulab-jamun-00", ratio: "4/5", caption: "Gulab Jamun · Macro", col: "col-span-12 md:col-span-5", offset: "" },
    { slug: "menu-lamb-dosa", ratio: "3/4", caption: "Lamb Dosa · Plate", col: "col-span-7 md:col-span-4", offset: "md:mt-16" },
    { slug: "hero-banquet-01", ratio: "16/10", caption: "Banquet · Editorial", col: "col-span-12 md:col-span-12 mt-2", offset: "" },
  ];

  // Filter out any missing
  const valid = layout.filter((item) => find(item.slug));

  return (
    <div data-testid="gallery-grid" className="grid grid-cols-12 gap-3 md:gap-5">
      {valid.map((item, i) => (
        <div key={i} className={`${item.col} ${item.offset}`}>
          <Photo
            slug={item.slug}
            alt={item.caption}
            ratio={item.ratio}
            caption={item.caption}
            sizes="(min-width: 1024px) 50vw, 100vw"
          />
        </div>
      ))}
    </div>
  );
};

export default GalleryGrid;
